import { render } from "./Service.vue?vue&type=template&id=3d0b6c7a&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import "./custom-product.scss?vue&type=style&index=0&id=3d0b6c7a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0b6c7a"]])

export default __exports__